<template>
	<Layout>
		<div class="container">
			<Loader :show="loading" />

			<div class="row row-xs mt-3">
				<div class="col-12">
					<div class="remainingTimer" v-if="remainingTime > 0" :class="{ warning: remainingTime <= 60 }">
						<i class="icon icon-clock"></i>{{ remainingTimeFormatted }}
						<span>Apurate! Tu reserva está a punto de caducar</span>
					</div>

					<div class="p-3 mt-2 only-desktop">
						<h2>Finalizar compra!</h2>
					</div>
				</div>

				<div class="col-12 col-lg-4" sticky-container>
					<div class="event-box" v-if="event" v-sticky="true" sticky-offset="{top: 10}" sticky-side="both">
						<div
							class="image"
							:style="
								`background-image:url(${event.imageCover ? event.imageCover.url : event.image.url})`
							"
						>
							<div class="data">
								<div class="tags">
									<h4 class="category">{{ event.category.name }}</h4>
									<div class="age" v-if="event.minAge">{{ event.minAge }}+</div>
								</div>

								<h1>{{ event.name }}</h1>

								<div class="place-date">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										class="icon icon-tabler icon-tabler-map-pin"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
										<circle cx="12" cy="11" r="3"></circle>
										<path
											d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
										></path>
									</svg>
									<span>
										<span class="text-white">{{ event.location.name }}</span
										>, {{ event.location.locality.name }}
									</span>
								</div>
							</div>
						</div>
						<div>
							<div class="cart">
								<div class="label mb-3">Resumen del pedido</div>
								<div class="cart-item" v-for="ticket in groupedTickets" :key="ticket.id">
									<div class="ticket">
										{{ ticket.quantity }} x {{ ticket.ticketType.name }}
										<div class="ticketGroup">
											{{ ticket.ticketType.ticketGroup.name }}
										</div>
									</div>

									<div>$ {{ ticket.price }}</div>
								</div>
								<div class="cart-item">
									<div class="ticket">
										Cargo por servicio
									</div>

									<div>$ {{ order.commission }}</div>
								</div>
								<div class="cart-total">
									<span>Total</span>
									<span>$ {{ order.total }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-8">
					<div class="tickets px-3" v-if="order">
						<FormulateForm name="form" v-model="formTickets" class="ticketForm" @submit="purchase">
							<FormulateInput type="group" name="tickets">
								<template v-for="(ticket, index) in order.tickets">
									<div :key="ticket.id">
										<div class="ticket">
											<div class="data">
												<div class="title">
													Entrada {{ index + 1 }} - {{ ticket.ticketType.name }}
												</div>
												<div class="ticketGroup">
													{{ ticket.ticketType.ticketGroup.name }}
												</div>

												<div
													class="warning"
													v-if="
														$moment(ticket.ticketType.ticketGroup.validAt) <
															$moment(order.event.endAt)
													"
												>
													Ingreso hasta la
													{{ ticket.ticketType.ticketGroup.validAt | moment("HH:mm") }}
												</div>
											</div>
											<div class="code">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													class="icon icon-tabler icon-tabler-qrcode"
													width="24"
													height="24"
													viewBox="0 0 24 24"
													stroke-width="2"
													stroke="currentColor"
													fill="none"
													stroke-linecap="round"
													stroke-linejoin="round"
												>
													<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
													<rect x="4" y="4" width="6" height="6" rx="1"></rect>
													<line x1="7" y1="17" x2="7" y2="17.01"></line>
													<rect x="14" y="4" width="6" height="6" rx="1"></rect>
													<line x1="7" y1="7" x2="7" y2="7.01"></line>
													<rect x="4" y="14" width="6" height="6" rx="1"></rect>
													<line x1="17" y1="7" x2="17" y2="7.01"></line>
													<line x1="14" y1="14" x2="17" y2="14"></line>
													<line x1="20" y1="14" x2="20" y2="14.01"></line>
													<line x1="14" y1="14" x2="14" y2="17"></line>
													<line x1="14" y1="20" x2="17" y2="20"></line>
													<line x1="17" y1="17" x2="20" y2="17"></line>
													<line x1="20" y1="17" x2="20" y2="20"></line>
												</svg>
											</div>

											<div class="form">
												<!-- <div
											class="row row-xs p-2 mr-2 mt-2"
											v-if="!ticket.ticketType.ticketGroup.holderRequired"
										>
											<div class="col-12">
												<div class="label">PORTADOR</div>
												<div class="ml-2" v-if="!ticket.ticketType.ticketGroup.holderRequired">
													<div class="holder">
														{{ user.name }} {{ user.lastname }}<br />
														{{ user.email }}<br />
														{{ user.phone.international }}
													</div>
												</div>
											</div>
										</div> -->
												<div
													class="row row-xs pt-2 px-4 pb-4"
													v-if="ticket.ticketType.ticketGroup.holderRequired"
												>
													<FormulateInput
														type="hidden"
														name="ticketId"
														:value="ticket.id"
														style="display:none"
													/>
													<div class="col-12">
														<div class="label">PORTADOR</div>
													</div>
													<div class="col-12 col-md-6 mb-2">
														<FormulateInput
															label="Nombre"
															name="name"
															validation-name="Nombre"
															validation="required"
														/>
													</div>
													<div class="col-12 col-md-6 mb-2">
														<FormulateInput
															label="Apellido"
															name="lastname"
															validation-name="Apellido"
															validation="required"
														/>
													</div>
													<div class="col-12 col-md-6 mb-2">
														<FormulateInput
															label="Documento de identidad"
															type="identification"
															name="document"
															validation-name="Documento de identidad"
															validation="bail|required|documentID"
														/>
													</div>
													<div class="col-12 col-md-6 mb-2">
														<FormulateInput
															label="Correo electrónico"
															type="email"
															name="email"
														/>
													</div>
													<div class="col-12">
														<div class="holder-warning">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																class="icon icon-tabler icon-tabler-alert-triangle"
																width="24"
																height="24"
																viewBox="0 0 24 24"
																stroke-width="2"
																stroke="currentColor"
																fill="none"
																stroke-linecap="round"
																stroke-linejoin="round"
															>
																<path
																	stroke="none"
																	d="M0 0h24v24H0z"
																	fill="none"
																></path>
																<path d="M12 9v2m0 4v.01"></path>
																<path
																	d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
																></path>
															</svg>
															Esta entrada sólo puede ser utilizada por la persona
															ingresada y deberá presentar su documento al momento del
															ingreso al evento
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</FormulateInput>
						</FormulateForm>
					</div>

					<div class="card ">
						<div class="card-body">
							<div class="alert">
								Al hacer clic en "Finalizar compra", acepta los términos de servicio y que ha leído la
								política de privacidad. Acepta que CobraTicket pueda compartir su información con el
								organizador del evento.
							</div>

							<div class="foot">
								<div class="btn btn-lg btn-primary btn-block" @click="$formulate.submit('form')">
									<span v-if="saving">Finalizando compra <span class="btn-loader" /> </span>
									<span v-else>Finalizar compra <span v-if="redirectToPay">y pagar</span> </span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import Loader from "@/components/Loader"
import EventData from "@/views/events/EventData"

export default {
	name: "TicketPurchase",
	components: {
		Layout,
		Loader,
		EventData
	},
	data() {
		return {
			loading: true,
			saving: false,
			order: null,
			event: null,
			user: null,
			formTickets: {
				tickets: [
					{
						ticketId: null,
						name: "",
						lastname: "",
						document: { number: null, type: "UY" },
						email: ""
					}
				]
			},
			redirectToPay: false,
			interval: null,
			remainingTimeFormatted: null,
			now: this.$moment().format("YYYY-MM-DD HH:mm:ss")
		}
	},

	async beforeMount() {
		this.loading = true

		if (!this.$route.params.orderId) {
			this.$router.go(-1)
			return null
		}
		await this.loadOrder()

		if (this.$store.getters.isAuthenticated) {
			this.user = this.$store.getters.loggedUser
		}
	},

	watch: {
		remainingTime: function(val) {
			if (val < 0) {
				clearInterval(this.interval)

				this.$dialog.alert({
					title: "Lo sentimos",
					body:
						"Han pasado más de 10 minutos sin que finalices tu compra, por lo que hemos liberado las entradas para que otros usuarios puedan tener acceso a ellas."
				})
				this.$router.push(`/e/${this.order.event.code}`)
			}
		}
	},
	computed: {
		// agrupo los tickets para mostrar el detalle de compra
		groupedTickets: function() {
			var groupedTickets = []
			//goup tickets by ticketType and sum quantity
			this.order.tickets.forEach(function(ticket) {
				var found = groupedTickets.find(function(groupedTicket) {
					return groupedTicket.ticketType.id == ticket.ticketType.id
				})
				if (found) {
					found.quantity++
					found.price = found.price + found.ticketType.priceUnit
				} else {
					groupedTickets.push({
						ticketType: ticket.ticketType,
						quantity: 1,
						price: ticket.ticketType.priceUnit
					})
				}
			})
			return groupedTickets
		},
		remainingTime: function() {
			if (this.order && this.order.reservedAt) {
				var a = this.$moment(this.now).unix()
				var b = this.$moment(this.order.reservedAt).unix()
				var diff = b - a

				this.remainingTimeFormatted = this.$moment()
					.startOf("day")
					.seconds(diff)
					.format("mm:ss")

				return diff
			}
			return null
		}
	},
	methods: {
		startCountdown() {
			this.interval = setInterval(() => {
				this.now = this.$moment(this.now)
					.add(1, "second")
					.format("YYYY-MM-DD HH:mm:ss")
			}, 1000)
		},

		// cargo la orden
		loadOrder() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!, $reservedAtUpdate: Boolean) {
							order(id: $id, reservedAtUpdate: $reservedAtUpdate) {
								id
								event {
									id
									code
								}
								tickets {
									id
									ticketType {
										id
										name
										priceUnit
										ticketGroup {
											id
											name
											validAt
											holderRequired
										}
									}
									currency
									price
								}
								user {
									id
									name
									lastname
									phone {
										countryCode
										national
										international
										type
										validated
									}
									email
									document {
										type
										number
									}
								}
								reservedAt
								subtotal
								commission
								total
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.orderId,
						reservedAtUpdate: true
					}
				})
				.then(async ({ data }) => {
					if (data.order.status == "CANCELLED") {
						this.$router.push(`/e/${data.order.event.code}`)
						return null
					}

					this.order = this.$omitDeep(data.order, "__typename")

					// reviso si la orden debe ser pagada
					if (this.order.total > 0) {
						this.redirectToPay = true
					}

					// si la orden ya tiene usuario, lo cargo a form
					// if (data.order.user) {
					// 	this.form.user[0] = {
					// 		name: data.order.user.name,
					// 		lastname: data.order.user.lastname,
					// 		document: data.order.user.document,
					// 		email: data.order.user.email,
					// 		phone: data.order.user.phone
					// 	}
					// }

					// cargo los tickets al form para que ingresen los holders
					// this.form.tickets = []
					// if (this.order.tickets) {
					// 	this.order.tickets.forEach((ticket) => {
					// 		if (ticket.ticketType.ticketGroup.holderRequired) {
					// 			this.form.tickets.push({
					// 				ticketId: ticket.id,
					// 				ticketType: ticket.ticketType,
					// 				name: "",
					// 				document: { number: null, type: "UY" },
					// 				email: "",
					// 				phone: {
					// 					countryCode: "UY"
					// 				}
					// 			})
					// 		}
					// 	})
					// }
					await this.loadEvent(this.order.event.id)

					this.startCountdown()
					this.loading = false
					return data.order
				})
		},

		loadEvent(id) {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								code
								name
								startAt
								endAt
								description
								minAge
								image {
									id
									type
									filename
									url
									urlThumb
								}
								imageCover {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										id
										name
										region {
											id
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								category {
									id
									name
								}
								ticketGroups {
									id
									name
									ticketTypes {
										id
										name
										priceUnit
									}
								}
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.event = data.event

					// obtengo el precio minimo y el maximo.
					// const minPrice = this.item.ticketGroups.reduce((min, item) => {
					// 	return item.ticketTypes.reduce((min, item) => {
					// 		return item.priceUnit < min ? item.priceUnit : min
					// 	}, min)
					// }, Infinity)
					// const maxPrice = this.item.ticketGroups.reduce((max, item) => {
					// 	return item.ticketTypes.reduce((max, item) => {
					// 		return item.priceUnit > max ? item.priceUnit : max
					// 	}, max)
					// }, 0)

					// this.item.prices = `$${minPrice} - $${maxPrice}`

					return true
				})
		},

		// proceso para finalizar la compra
		async purchase() {
			console.log(" purchase", this.formTickets)

			if (!this.saving) {
				this.saving = true

				// creo el pedido asignando el usuario a la orden y la confirmo.
				const order = await this.orderConfirm()
				if (!order) throw new Error("Error al confirmar la orden")

				if (!this.redirectToPay) {
					this.saving = false
					this.$router.push(`/account/tickets`)
					return
				}
				const transaction = await this.transactionCreate()
				if (transaction) {
					// console.log(`transaction: ${transaction}`)

					// redirecciono a la pagina de pago
					if (transaction.paymentRedirectUrl) {
						window.location.href = transaction.paymentRedirectUrl
					}
				}
				this.saving = false
			}
		},

		// creo al usuario

		// confirmo la orden
		async orderConfirm() {
			let data = {
				userId: this.user.id,
				tickets: []
			}

			// agrego los tickets de la orden, y le cargo los holders del form.
			this.order.tickets.forEach((ticket) => {
				if (ticket.ticketType.ticketGroup.holderRequired) {
					const holder = this.formTickets.tickets.find((t) => t.ticketId == ticket.id)
					data.tickets.push({
						id: ticket.id,
						holder: {
							name: holder.name,
							lastname: holder.lastname,
							document: holder.document,
							email: holder.email
							// phone: holder.phone.validated ? holder.phone : null
						}
					})
				} else {
					data.tickets.push({
						id: ticket.id,
						holder: null
					})
				}
			})

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: OrderInput!) {
							orderConfirm(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.order.id,
						data
					}
				})
				.then(({ data }) => {
					return data.orderConfirm
				})
				.catch((error) => {
					this.parseGQLErrors(error)
				})
		},

		// creo la transaccion
		async transactionCreate() {
			console.log("transactionCreate")

			let data = {
				orderId: this.order.id
			}

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: TransactionInput!) {
							transactionCreate(data: $data) {
								id
								paymentRedirectUrl
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					console.log("transactionCreate return", data.transactionCreate)
					return data.transactionCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.content {
	display: flex;
	align-items: flex-start;

	&:first-child {
		flex-grow: 1;
	}
}

.event-box {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border-radius: 8px;
	background-color: #000;
	max-width: 380px;
	margin-bottom: 16px;

	.image {
		width: 100%;
		position: relative;
		background-position: center;
		background-repeat: no-repeat;

		&:before {
			background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);

			bottom: 0;
			content: "";
			left: 0;

			position: absolute;
			right: 0;
			top: 0;
			z-index: 1;
		}
		.data {
			position: inherit;
			padding: 4rem 2rem 2rem 2rem;
			color: #fff;
			z-index: 2;

			.tags {
				display: flex;
				align-items: center;

				& > * {
					margin-right: 4px;
					font-size: 0.8rem;
					background: #595959;
					border-radius: 4px;
					padding: 6px 10px;
					font-weight: 400;
					display: inline;
					height: 24px;
					line-height: 0.8rem;
					text-transform: uppercase;
				}
				.category {
					font-weight: 500;
				}
			}

			h1 {
				font-size: 2rem;
				line-height: 2.4rem;
				font-weight: 700;
				margin-top: 0.5rem;
			}
			.place-date {
				margin-top: 0.5rem;
				display: flex;
				align-items: center;
				font-size: 1rem;
				color: #cacaca;

				svg {
					margin-right: 8px;
					width: 18px;
				}
			}
		}
	}

	.cart {
		color: #fff;
		width: 100%;
		padding: 22px;

		.label {
			font-size: 1rem;
			font-weight: 400;
			color: #787878;
		}

		.cart-item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 0px;
			border-bottom: 1px solid #3b3b3b;
			min-height: 50px;

			.ticket {
				font-size: 0.9rem;
				line-height: 1rem;
				font-weight: 400;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				border: none;

				.ticketGroup {
					color: #b9b9b9;
					font-size: 0.8rem;
				}
			}
		}

		.cart-total {
			// border-top: 1px solid #eeedf2;
			padding: 16px 0px;
			font-weight: 500;
			font-size: 1rem;
			display: flex;
			justify-content: space-between;
		}
	}
}

.tickets {
	display: flex;
	flex-direction: column;

	.ticketForm {
		min-width: 100%;
	}

	.ticket {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		width: 100%;
		border-radius: 8px;
		border: 1px solid #dcdcdc;
		margin-bottom: 30px;
		margin-top: -14px;

		.code {
			width: 100px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #3b3b3b;
			flex-shrink: 0;
			svg {
				margin-top: 8px;
				width: 74px;
				height: 74px;
			}
		}
		.data {
			padding: 16px;
			flex-grow: 1;

			.title {
				font-size: 1.2rem;
				font-weight: 500;
				color: #000;
			}
			.ticketGroup {
				font-size: 0.9rem;
				font-weight: 500;
				line-height: 1rem;
				color: #4f4f4f;
			}

			.warning {
				background-color: #fdc100;
				font-size: 0.8rem;
				padding: 2px 8px;
				margin-top: 4px;
				border-radius: 5px;
				display: inline-block;
				color: #fff;
			}

			.holder {
				line-height: 1rem;
			}
		}

		.form {
			.label {
				font-size: 0.8rem;
				font-weight: 500;
				color: #909090;
			}

			.holder-warning {
				background-color: #fdc10040;
				font-size: 0.9rem;
				line-height: 1.2rem;
				padding: 8px 12px;
				margin-top: 4px;
				border-radius: 5px;
				display: flex;
				color: #d3a202;
				svg {
					width: 22px;
					height: 22px;
					flex-shrink: 0;
					margin-right: 8px;
				}
			}
		}
	}
}

.card {
	width: 100%;
	background-color: transparent;
}

.remainingTimer {
	position: fixed;
	bottom: 12px;
	right: 12px;

	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 2;
	font-size: 1.1rem;
	color: rgb(168, 168, 168);
	font-weight: 500;
	border-radius: 22px;
	padding: 4px 12px;
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);

	.icon {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	span {
		display: none;
	}
	&.warning {
		background-color: #ffc107;
		color: #fff;
		span {
			display: inline-block;
			font-size: 0.9rem;
			margin-left: 8px;
		}
	}
}
.alert {
	color: #6f7287;
	background-color: #f8f7fa;
}

@media (max-width: 768px) {
	.content {
		display: block;
		max-width: 380px;
		margin: auto;
	}
}
@media (max-width: 576px) {
	.container {
		padding: 0px;
	}
	.content {
		max-width: 100%;
	}
	.event-box {
		max-width: 100%;
		margin-left: 0px;
		margin-right: 0px;
		border-radius: 0px;
	}
}
</style>
